import React from 'react';
import PropTypes from 'prop-types';

import membersStrings from 'modules/members/strings';
import alertImg from 'assets/images/alert.png';
import { searchQueryMinLength } from 'constants/members';

import {
  TableWrapper,
  TableGridWrapper,
  TableHeader,
  TableDivider,
  TableItem,
  TableItemText,
  PointsIcon,
  EmptyState,
  EmptyStateText,
  EmptyStateSubText,
  Img,
} from './MembersList.style';

const MembersList = ({ membersList, searchQuery }) => {
  const { gridHeaderList, emptyStateText, emptyStateSubText } = membersStrings.membersList;
  return (
    <>
      {membersList.details.data.length === 0 && searchQuery.length >= searchQueryMinLength && (
        <EmptyState>
          <Img src={alertImg} />
          <EmptyStateText>{emptyStateText}</EmptyStateText>
          <EmptyStateSubText>{emptyStateSubText}</EmptyStateSubText>
        </EmptyState>
      )}
      {membersList.details.data.length > 0 && (
        <TableWrapper>
          <TableGridWrapper>
            <TableDivider />
            {Object.keys(gridHeaderList).map(GridHeaderKey => (
              <TableHeader key={GridHeaderKey}>{gridHeaderList[GridHeaderKey]}</TableHeader>
            ))}
            <TableDivider />
            {membersList.details.data.map(item => (
              <React.Fragment key={item.userEmail}>
                <TableItem>
                  <TableItemText as="a" href={`/member/${item.userEmail}`}>
                    {item.userEmail}
                  </TableItemText>
                </TableItem>
                <TableItem>
                  <PointsIcon />
                  <TableItemText>{item.availablePoints}</TableItemText>
                </TableItem>
                <TableDivider />
              </React.Fragment>
            ))}
          </TableGridWrapper>
        </TableWrapper>
      )}
    </>
  );
};

MembersList.propTypes = {
  membersList: PropTypes.shape({
    status: PropTypes.string,
    details: PropTypes.shape({
      data: PropTypes.arrayOf(PropTypes.shape({})),
      pageSize: PropTypes.number,
    }),
  }).isRequired,
  searchQuery: PropTypes.string,
};

MembersList.defaultProps = {
  searchQuery: '',
};

export default MembersList;
